import React, { useMemo } from 'react';
import OrganizationAnalyticsBarChart from './OrganizationAnalyticsBarChart';
import { mapIdsToLabels } from './chartUtils';

const OrganizationChatterPurchasesByChatterChart = ({ data, chatterLabelMap, pending }) => {
  const { categories, series } = useMemo(() => {
    const chatterIds = data?.chatterIds || [];
    const purchaseCount = data?.purchaseCount || [];
    const rows = chatterIds
      .map((chatterId, index) => ({
        category: mapIdsToLabels([chatterId], chatterLabelMap)[0],
        purchaseCount: Number(purchaseCount[index] || 0),
      }))
      .sort(
        (firstRow, secondRow) =>
          secondRow.purchaseCount - firstRow.purchaseCount || firstRow.category.localeCompare(secondRow.category),
      );

    return {
      categories: rows.map(row => row.category),
      series: [{ name: 'Purchases', data: rows.map(row => row.purchaseCount) }],
    };
  }, [data, chatterLabelMap]);

  return (
    <OrganizationAnalyticsBarChart
      title="Purchases By Chatter"
      subtitle="Purchase volume for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select creators and chatters to load purchase totals."
      valueType="number"
    />
  );
};

export default OrganizationChatterPurchasesByChatterChart;
